import styled from '@emotion/styled';

import { capitalizeWords } from '../../../utils/utils';

interface TableFirstAndLastNameFormatterProps {
  data?: Record<string, any>;
  firstNameDataKey: string;
  lastNameDataKey?: string;
  className?: string;
}

const TableFirstAndLastNameFormatter: React.FC<
  TableFirstAndLastNameFormatterProps
> = ({ data, firstNameDataKey, lastNameDataKey, className }) => {
  const lastName = data && data[lastNameDataKey ?? ''];
  const firstName = data && data[firstNameDataKey ?? ''];
  return (
    <Container className={className}>
      {firstName || lastName ? (
        `${capitalizeWords(String(firstName))} ${capitalizeWords(String(lastName))}`
      ) : (
        <EmptyCell>N/A</EmptyCell>
      )}
    </Container>
  );
};

export default TableFirstAndLastNameFormatter;

const Container = styled.div`
  word-break: break-word;
  width: 100%;
`;

const EmptyCell = styled.div`
  color: ${({ theme }) => theme.palette.tertiaryTextColor};
  font-size: 14px;
  font-weight: 700;
  padding: 16px;
  text-align: left;
`;
